__webpack_require__.p = "https://xplorefitness.cz/wp-content/themes/fitness-wellness/reservations_frontend_react/build/";